<template lang="pug">
    //- Status
    .cell-content-wrapper.l-flex-row.l-align-center
        div.row-item-status(
            :title="getStatus"
            :class="`item-${fullData.status}`")
        div.css-cut-long-text.row-item-label(:title="data") {{ fullData.label }}

</template>

<script>
export default {
    props: {
        data: {
            type: [Function, Array, String, Number],
            default: null
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        getStatus () {
            if(this.fullData.jsonKey && this.fullData.jsonKey.type === 'Cclone' && this.fullData.status === 'failed' && !!this.fullData.status_message) {
                return `${this.fullData.status}: ${this.fullData.status_message.toLowerCase()}`
            }
            return this.fullData.status
        }
    }
}
</script>
